module.exports = __webpack_public_path__ + "static/media/Prompt-Bold.befa1f27.ttf";